export enum CustomerBuys {
  SingleBuy = 'single_buy',
  MultiBuyRental = 'multi_buy_or_rental',
}
